import { ChangeDetectionStrategy, AfterViewInit, Component, OnInit, ViewChild, input } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule, IonInput, ModalController } from '@ionic/angular';
import { ModeService } from 'src/app/utils/mode.service';

@Component({
    selector: 'app-comment-dialog',
    templateUrl: './comment-dialog.component.html',
    styleUrls: ['./comment-dialog.component.scss'],
    imports: [IonicModule, FormsModule, ReactiveFormsModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommentDialogComponent implements OnInit, AfterViewInit {
  @ViewChild("input") input!: IonInput;
  readonly comment = input<string>(undefined);

  public commentForm: FormGroup;
  constructor(public modeService: ModeService, private modalController: ModalController) {
    this.commentForm = new FormGroup({
      comment: new FormControl(''),
    });
  }

  ngOnInit() {
    this.commentForm.patchValue({
      comment: this.comment()
    })
  }

  ngAfterViewInit() {
    setTimeout(() => {
        this.input.setFocus();
    },150);
  }

  delete() {
    if ((this.modalController.getTop()) !== undefined) {
      this.modalController.dismiss(null, 'delete');
    }
  }

  cancel() {
    if ((this.modalController.getTop()) !== undefined) {
      this.modalController.dismiss(null, 'cancel');
    }
  }
  
  save() {
    if ((this.modalController.getTop()) !== undefined) {
      this.modalController.dismiss(this.commentForm.value.comment);
    }
  }

}
